import { BankName } from 'commons/types/enums'
import { ChoiceOption } from 'ui/types'

import { SelectListName } from './selectListName'

const regions = [
  'AK',
  'AL',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
  'DC'
]

export const getOptionsByListName = (name: SelectListName): ChoiceOption[] => {
  if (name === SelectListName.FREQUENCY) {
    return [
      { label: 'Every 5 years', value: 'every_5_years' },
      { label: 'Every 2 years', value: 'every_2_years' },
      { label: 'Every 18 Months', value: 'every_18_months' },
      { label: 'Annual', value: 'annual' },
      { label: 'Semi-Annual', value: 'semi-annual' },
      { label: 'Quarterly', value: 'quarterly' },
      { label: 'Monthly', value: 'monthly' },
      { label: 'One-Time', value: 'one-time' },
      { label: 'Manual Period', value: '' }
    ]
  }

  if (name === SelectListName.START_DATE_TYPE) {
    return [
      { label: 'Account Opening', value: 'account_opening' },
      { label: 'Calendar', value: 'calendar' },
      { label: 'License Issue', value: 'license_issue' },
      { label: 'Last Delivery', value: 'last_delivery' },
      { label: 'Manual Period', value: '' }
    ]
  }

  if (name === SelectListName.STATE_OF_INCORPORATION) {
    return regions.map((state) => ({ label: state, value: state }))
  }

  if (name === SelectListName.DUE_START_DATE) {
    return [
      { label: 'Period Start', value: true },
      { label: 'Period End', value: false }
    ]
  }

  if (name === SelectListName.ORGANISATIONS) {
    return [
      { label: 'Development Bank', value: BankName.DEV },
      { label: 'Shore United Bank', value: BankName.SHORE },
      { label: 'CB&T', value: BankName.CBT },
      { label: 'Illinois National Bank', value: BankName.INB },
      { label: 'Herring Bank', value: BankName.HERRING },
      { label: 'Transact Bank', value: BankName.TRANSACT },
      { label: 'Champion Bank', value: BankName.CHAMPION },
      { label: 'Flagler Bank', value: BankName.FLAGLER },
      { label: 'Valliance Bank', value: BankName.VALLIANCE },
      { label: 'Bison State Bank', value: BankName.BISON }
    ].sort((a, b) => a.label.localeCompare(b.label))
  }

  if (name === SelectListName.SUBJECT) {
    return [
      { label: 'Relationship', value: 'company' },
      { label: 'License', value: 'license' },
      { label: 'Bank Account', value: 'bank_account' },
      { label: 'Contact', value: 'contact' }
    ]
  }

  return []
}
